import { lazy } from "react";

export const LazyMadeInAustralia = lazy(() =>
  import(
    /* webpackChunkName: "retailer-made-in-australia-icon" */
    "@faire/web/slate/icons/foundation/illustrations/MadeInAustralia"
  ).then((m) => ({ default: m.MadeInAustralia }))
);
